import mercury from '../api/mercury';
import BaseFetch from './base';

export default class Mercury extends BaseFetch {
    api = mercury
}
